


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LoginPromptDialog extends Vue {
    public showDialog: boolean = false;
    public contentMessage: string = 'You must login to view this';

    get config() {
        return this.$store.state.config;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'showLoginPromptDialog') {
            this.onShowDialog(action.payload);
        }
    });

    public onShowDialog(contentMessage: string) {
        this.showDialog = true;
        this.contentMessage = contentMessage;
    }

    public closeDialog() {
        this.showDialog = false;
    }

    public redirect() {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        window.dataLayer.push({'event': 'login'});

        this.$store.dispatch('login');
    }
}
